import fetch from "@lib/fetch";
import { API } from "../../config";

export const saveTracking = (data) => {
    return fetch(`${API}/v1/public/tools/tracking_notifications`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(res => {
      return res.json()
    })
    .catch(error => {
      console.log(error);
    })
  };